/**
 * Hardcoded whitelist of dev team members for restricted features.
 * Temporary lockdown — replace with role-based access later.
 */
const ALLOWED_EMAILS = [
  'tara@clubwealth.com',
  'omerson.e.cruz@gmail.com',
  'cruzomerson@gmail.com',
  'henryybalez33@gmail.com'
];

const ALLOWED_NAMES = ['omerson cruz', 'henry ybalez', 'tara hellickson'];

/**
 * Check if a user is in the dev whitelist.
 * @param {object} user - user_bundle.user object
 * @returns {boolean}
 */
export const isDevWhitelisted = (user) => {
  if (!user) return false;

  const email = (user.auth_email || '').toLowerCase().trim();
  if (ALLOWED_EMAILS.includes(email)) return true;

  const fullName = `${user.first_name || ''} ${user.last_name || ''}`
    .toLowerCase()
    .trim();
  if (ALLOWED_NAMES.includes(fullName)) return true;

  return false;
};
